import React, { useEffect, useState } from 'react';
import { useTheme } from 'ThemeContext';
import { FormattedMessage } from 'react-intl';
import {
  Wrapper,
  Container,
  Box,
  InfoContainer,
  Title,
  Text,
  Info,
  CalendarTop,
  ArrowButton,
  DayNamesWrapper,
  Image,
  MonthYear,
  Table,
  Day,
  Link,
  Event,
  DayName
} from './WidgetCalendar.style';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft as arrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faChevronCircleRight as arrowRight } from '@fortawesome/free-solid-svg-icons';

function WidgetCalendar({
  data = [],
  todayDate,
  slug = '',
  showEvents = true
}) {
  const theme = useTheme();
  const now = moment(todayDate, 'YYYY/MM/DD');
  const [day, setDay] = useState(moment(now).date());
  const [month, setMonth] = useState(moment(now, 'YYYY/MM/DD').month() + 1);
  const [year, setYear] = useState(moment(now).year());
  const [selectedDay, setSelectedDay] = useState(`${todayDate}`);
  const [open, setOpen] = useState(false);
  let [indexDay, setIndexDay] = useState(0);

  const monthName = [
    'Styczeń',
    'Luty',
    'Marzec',
    'Kwiecień',
    'Maj',
    'Czerwiec',
    'Lipiec',
    'Sierpień',
    'Wrzesień',
    'Październik',
    'Listopad',
    'Grudzień'
  ];

  const dayName = ['pn', 'wt', 'śr', 'czw', 'pt', 'so', 'nd'];

  const startWeekDay = moment(`${year}/${month}/1`).isoWeekday();

  const handleChange = (id, d) => {
    setDay(d);
    setOpen(false);
    setSelectedDay(`${year}/${month}/${d}`);
    setOpen(true);
    setIndexDay(id);
  };

  const handleClickDay = d => {
    data.map((item, id) => {
      if (item.date === `${year}/${month}/${d}`) {
        handleChange(id, d);
      }
    });
  };

  const numberDaysInMonth = moment(`${year}/${month}`, 'YYYY/MM').daysInMonth();

  let activeDayWithMonth = [];
  let daysInMonth = [];

  for (let d = 1; d <= numberDaysInMonth; d++) {
    daysInMonth.push(d);

    for (let i = 0; i < data.length; i++) {
      if (`${year}/${month}/${d}` === data[i].date) {
        activeDayWithMonth.push(`${year}/${month}/${d}`);
      }
    }
  }

  const handleMonth = option => {
    if (option === 'previous') {
      if (month > 1) {
        setMonth(month - 1);
      } else {
        setMonth(12);
        setYear(year - 1);
      }
    } else if (option === 'next') {
      if (month < 12) {
        setMonth(month + 1);
      } else {
        setMonth(1);
        setYear(year + 1);
      }
    }
  };

  //get today's, first of near future or last previous
  useEffect(() => {
    selectFirstDay();
  }, [data]);

  //get today's, first of near future or last previous
  function selectFirstDay() {
    const momentNow = moment(now);
    if (!data || !data.length) return false;
    const indexOfFuture = data.findIndex(item => {
      return moment(item.date) >= momentNow;
    });
    if (indexOfFuture > -1) {
      setIndexDay(indexOfFuture);
    } else {
      //backend send ordered by date ASC
      setIndexDay(data.length - 1);
    }
  }

  return (
    <Wrapper theme={theme.widgetCalendar}>
      <Container theme={theme.widgetCalendar.container}>
        <Box theme={theme.widgetCalendar.box}>
          <CalendarTop theme={theme.widgetCalendar.calendarTop}>
            <ArrowButton
              onClick={() => handleMonth('previous')}
              theme={theme.widgetCalendar.arrowButton}
            >
              <FontAwesomeIcon icon={arrowLeft} option='previous' />
            </ArrowButton>
            <MonthYear theme={theme.widgetCalendar.monthYear}>
              {monthName[month - 1]} {year}
            </MonthYear>
            <ArrowButton
              onClick={() => handleMonth('next')}
              theme={theme.widgetCalendar.arrowButton}
            >
              <FontAwesomeIcon icon={arrowRight} option='next' />
            </ArrowButton>
          </CalendarTop>
          <DayNamesWrapper theme={theme.widgetCalendar.dayNamesWrapper}>
            {dayName.map((item, index) => (
              <DayName key={index} theme={theme.widgetCalendar.dayName}>
                {item}
              </DayName>
            ))}
          </DayNamesWrapper>
          <Table theme={theme.widgetCalendar.table}>
            {daysInMonth.map((item, index) => (
              <Day
                key={item}
                onClick={() => handleClickDay(item)}
                theme={theme.widgetCalendar.day}
                selected={selectedDay === `${year}/${month}/${index + 1}`}
                clickable={activeDayWithMonth.includes(
                  `${year}/${month}/${item}`
                )}
                startColumn={startWeekDay}
                weekend={
                  moment(`${year}/${month}/${item}`).isoWeekday() === 6 ||
                  moment(`${year}/${month}/${item}`).isoWeekday() === 7
                }
              >
                {item}
              </Day>
            ))}
          </Table>
        </Box>

        <InfoContainer>
          {showEvents && (
            <>
              {open ? (
                <Info>
                  {data &&
                    data[indexDay] &&
                    data[indexDay].events.map((event, index) => (
                      <Event
                        key={index}
                        to={event.slug}
                        theme={theme.widgetCalendar.event}
                      >
                        <Title theme={theme.widgetCalendar.title}>
                          {`${moment(data[indexDay].date, 'YYYY/MM/DD').format(
                            'DD.MM.YYYY'
                          )} - ${event.title}`}
                        </Title>
                        <Text theme={theme.widgetCalendar.text}>
                          {event.text}
                        </Text>
                      </Event>
                    ))}
                </Info>
              ) : (
                <Info>
                  {data &&
                    data[indexDay] &&
                    data[indexDay].events.map((event, index) => (
                      <Event
                        key={index}
                        to={event.slug}
                        theme={theme.widgetCalendar.event}
                      >
                        <Title theme={theme.widgetCalendar.title}>
                          {`${moment(data[indexDay].date, 'YYYY/MM/DD').format(
                            'DD.MM.YYYY'
                          )} - ${event.title}`}
                        </Title>
                        <Text theme={theme.widgetCalendar.text}>
                          {event.text}
                        </Text>
                      </Event>
                    ))}
                </Info>
              )}
            </>
          )}
        </InfoContainer>
      </Container>
    </Wrapper>
  );
}

export default WidgetCalendar;
